export interface EventsTypesOptions {
  name: string;
  value: string;
}

export const EventsTypesOptions: EventsTypesOptions[] = [
  {
    name: "EventsTypesOptions.LifestylePrograms",
    value: "Lifestyle Programs"
  },
  {
    name: "EventsTypesOptions.Notice",
    value: "Notice"
  },
  {
    name: "EventsTypesOptions.Meal",
    value: "Meal"
  },
  {
    name: "EventsTypesOptions.PremiumServices",
    value: "Premium Services"
  },
  {
    name: "EventsTypesOptions.ConciergeRequest",
    value: "conciergeRequest"
  }
];
